<template>
    <div class="">
        <div class="center-section py-1">
            <div class="center-content">
                <div class="preview-elements pr-3 py-3 px-4">
                    <ul class="nav nav-tabs nav-fill nav-profile px-4 py-4" id="myTab" role="tablist" style="background: white; border-radius:10px;">
                        <ul class="nav new-nav-text fw-500 mb-3">
                            <li>Template: Check-in and Check-out</li>
                        </ul>
                        <li class="nav-item">
                            <a  class="new-nav-text mb-2 text-capitalize" role="tab" aria-controls="emergencycontact" aria-expanded="true" aria-selected="false">
                                <p class="fs-13">1. Check-in Template</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a  class="new-nav-text mb-2 text-capitalize" role="tab" aria-controls="emergencycontact" aria-expanded="true" aria-selected="false">
                                <p class="fs-13">2. Wait in Queue Template</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="changeView('check_out_template')" class="new-nav-text mb-2 text-capitalize" role="tab" aria-controls="configureshift" aria-expanded="true" aria-selected="false" v-bind:class="{ active: check_out_template}">
                                <p class="fs-13">3. Check-out Template</p>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content profile-tab-content scroll-media px-4 py-4" id="myTabContent" style="background: white; border-radius: 10px;">
                        <div class="" id="check_out_template" aria-labelledby="configureshift-tab" v-if="check_out_template">
                            <check-out-template></check-out-template>
                        </div>
                        <!-- <div class="mt-3" id="reports_generation_schedule" aria-labelledby="reportsgenerationschedule-tab" v-if="reports_generation_schedule">
                            <reports-generation-schedule></reports-generation-schedule>
                        </div>
                        <div class="mt-3" id="configure_qr_code" aria-labelledby="configureqrcode-tab" v-if="configure_qr_code">
                            <configure-qr-code></configure-qr-code>
                        </div>
                        <div class="mt-3" id="facility_area_location_setup" aria-labelledby="facilityarealocationsetup-tab" v-if="facility_area_location_setup">
                            <facility-area-and-location></facility-area-and-location>
                        </div>
                        <div class="mt-3" id="emergency_contact" aria-labelledby="emergencycontact-tab" v-if="emergency_contact">
                            <list-emergency-contact></list-emergency-contact>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from '../../eventBus/nav-bar-event';
const CheckOutTemplate = () => import('./CheckOutTemplate');
// const ReportsGenerationSchedule = () => import('./ReportsGenerationSchedule');
// const ConfigureQrCode = () => import('./ConfigureQrCode');
// const FacilityAreaAndLocation = () => import('./FacilityAreaAndLocation.vue')
// const ListEmergencyContact = () => import('./ListEmergencyContact.vue')
export default {
    components:{
        HalfCircleSpinner,
        // QrcodeVue,
        CheckOutTemplate,
        // ReportsGenerationSchedule,
        // ConfigureQrCode,
        // FacilityAreaAndLocation,
        // ListEmergencyContact
    },
    data(){
        return{
            ajaxCallinprogress:false,
            profile_data:{},
            valueqr: "https://example.com",
            size: 90,
            check_out_template:false,
            // reports_generation_schedule:false,
            // configure_qr_code:false,
            // facility_area_location_setup:false,
            // emergency_contact: false
        }
    },
    methods:{
        changeView(value){
            if(value == 'check_out_template'){
                this.check_out_template = true
                // this.reports_generation_schedule = false
                // this.configure_qr_code = false
                // this.emergency_contact = false;
                // this.facility_area_location_setup = false
            }
            // }else if(value == 'reports_generation_schedule'){
            //     this.configure_shift = false
            //     this.reports_generation_schedule = true
            //     this.configure_qr_code = false
            //     this.emergency_contact = false;
            //     this.facility_area_location_setup = false
            // }else if(value == 'configure_qr_code'){
            //     this.configure_shift = false
            //     this.reports_generation_schedule = false
            //     this.configure_qr_code = true
            //     this.emergency_contact = false;
            //     this.facility_area_location_setup = false
            // }else if(value == 'facility_area_location_setup'){
            //     this.configure_shift = false
            //     this.reports_generation_schedule = false
            //     this.configure_qr_code = false
            //     this.emergency_contact = false;
            //     this.facility_area_location_setup = true
            // }else if(value == 'emergency_contact'){
            //     this.configure_shift = false
            //     this.reports_generation_schedule = false
            //     this.configure_qr_code = false
            //     this.facility_area_location_setup = false
            //     this.emergency_contact = true;
            // }
        }
    },
    computed:{    
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
    }
}
</script>
<style scoped>
.new-nav-text.active {
    color: #0000FF; /* Blue color */
    font-weight: bold; /* Make it darker */
    border-bottom: 2px solid #0000FF !important; /* Blue underline */
}

.new-nav-text{
    color: #005dae !important;
}

.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    color: #005dae;
    background-color: transparent;
}

.nav-tabs.nav-profile .nav-link.active:not(.dropdown-toggle):after,
.nav-tabs.nav-profile .nav-item.show .nav-link:not(.dropdown-toggle):after {
    background-color: transparent !important;
    content: none !important;
}

.nav.nav-tabs.nav-profile {
    width: 100%;
    background: transparent;
    border-radius: 0px 0px 0px 0px;
    padding-bottom: 15px;
    border-bottom: 1px solid #808495;
    display: inline-block;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: auto;
    /* max-height: 8em; */
}

.nav-tabs.nav-profile .nav-link.active {
    overflow: visible;
}

.nav-tabs.nav-profile .nav-link:hover,
.nav-tabs.nav-profile .nav-link:focus {
    border-color: #005dae;
    background-color: #005dae;
    color: #fff !important;
}

.nav-tabs.nav-profile .nav-link {
    border: 1px solid #00448f;
    position: relative;
    display: block;
    height: 48px !important;
    margin-right: 10px;
    line-height: 48px;
    border-radius: 12px;
    margin-right: 10px;
    color: #00448f;
}

.nav-tabs.nav-profile .nav-link.active,
.nav-tabs.nav-profile .nav-item.show .nav-link {
    border-color: #00448f;
    background-color: #00448f;
    color: #fff;
}

.nav-tabs.nav-profile .nav-link img {
    display: inline-block;
    text-align: center;
    margin: 8px auto 6px;
}

.nav-tabs.nav-profile .nav-link i {
    display: inline-block;
    text-align: center;
    margin: 12px auto 6px;
    font-size: 16px !important;
    width: 42px;
    height: 14px;
    line-height: 14px;
    color: #808495;
}

.nav-tabs.nav-profile .nav-link.active i,
.nav-tabs.nav-profile .nav-item.show .nav-link i {
    color: #fff !important;
}

.nav-tabs.nav-profile .nav-link:hover i,
.nav-tabs.nav-profile .nav-link:focus i {
    color: #fff;
}

.nav-tabs.nav-profile .nav-link h6 {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    color: #005dae;
}

.nav-tabs.nav-profile .nav-link.active h6,
.nav-tabs.nav-profile .nav-item.show .nav-link h6 {
    color: #fff;
}

.nav-tabs.nav-profile .nav-link:hover h6,
.nav-tabs.nav-profile .nav-link:focus h6 {
    color: #fff;
}

.tab-content.profile-tab-content {
    padding: 10px 0px;
    overflow-y: auto;
    overflow-x: hidden;
}

.pointerEventsNone {
    pointer-events: none !important;
}
.nav li.nav-item{
    min-width: 21%;
    display: inline-block;
    cursor: pointer;
}
</style>